class UrlWorker {
  
  static getSearchParams(search_str) {
    let str    = search_str || window.location.search;
    let blocks = [];
    let params = {};

    if (!str) {
      return {};
    } else if (typeof str !== 'string') {
      return search_str;
    }

    str = str.replace(/^\?/, '');

    blocks = str.split('&');

    blocks.forEach((block) => {
      let key   = block.split('=')[0];
      let value = block.split('=')[1];

      params[key] = value;
    });

    return params;
  }
  
  /**
   * @deprecated
   * @use {@link getSearchParams}
   *
   * @param {string} search_str
   */
  static get_search_params (search_str) {
    return this.getSearchParams(search_str);
  }
  
  /**
   * Dato una stringa URL contenente un hash, ne ritorna i parameti sotto forma di oggetto.
   * Questo richiede che il contenuto dell'hash sia scritto con la stessa logica dei queryParams,
   * quindi #chiave=valore&chiave=valore.
   *
   * @param {string} hashString
   * @returns {{}}
   */
  static getHashParams(hashString) {
    let str    = hashString || window.location.hash;
    let blocks = [];
    let params = {};
  
    if (!str) {
      return {};
    }
  
    str = str.replace(/^\#/, '');
  
    if (!str.includes('=')) {
      return str;
    }
  
    blocks = str.split('&');
  
    blocks.forEach((block) => {
      let key   = block.split('=')[0];
      let value = block.split('=')[1];
    
      params[key] = value;
    });
  
    return params;
  }
  
  /**
   * @deprecated
   * @use {@link getHashParams}
   *
   * @param {string} hashString
   * @returns {{}}
   */
  static get_hash_params(hashString){
    return this.getHashParams(hashString)
  }
  
  /**
   * Converte un oggetto in una stringa url valida, quindi formattata "chiave=valore&chiave=valore"
   *
   * @param {{}} params
   * @returns {string}
   */
  static stringifyParams (params) {
    if (!params || params.constructor.name !== 'Object') {
      return '';
    }
  
    const str           = [];
    const merged_params = { ...params };
  
    Object.keys(merged_params).forEach((key) => {
      let value = merged_params[key];
    
      if (typeof value !== 'number' && typeof value !== 'boolean' && !value) {
        return;
      }
    
      if (typeof value !== 'string') {
        value = JSON.stringify(value);
      }

      str.push(key + '=' + value);
    });

    return str.join('&');
  }
  
  /**
   * @deprecated
   * @use {@link stringifyParams}
   *
   * @param {{}} params
   * @returns {string}
   */
  static stringify_params (params) {
    return this.stringifyParams(params)
  }
}

export { UrlWorker };

